// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3puUG","image":"styles_image__2ZV84","submitButton":"styles_submitButton__1m4K6","clickHere":"styles_clickHere__2FQvh"};